<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-forward`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 15.37c-12.15 0-22 9.992-22 22.318 0 .766.083 1.795.248 3.088a.5.5 0 00.92.202l.317-.496c.304-.467.57-.847.798-1.14 3.586-4.616 9.448-7.225 17.17-7.331L25 32.007v8.975a1.033 1.033 0 001.756.72L43.548 25.08a1.517 1.517 0 000-2.16L26.756 6.298a1.036 1.036 0 00-1.455 0c-.193.191-.301.45-.301.72v8.352zm0 4h4v-5.222L38.953 24 29 33.852v-5.845h-6.052c-5.805 0-10.882 1.263-14.972 3.713C10.41 24.529 17.12 19.37 25 19.37z"/></svg>
</template>
<script>

export default {
  name: 'IconForward',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
